import '../App.css';
import '../Tileandpopout.css';
import { useState } from 'react';
import SketchTile from '../components/SketchTile';

const Sketches = ( {sketches} ) => {
    const [curr, setCurr] = useState({})

    return(
        <div className='tabs-border'>
        <div className='work-flex'>
            {sketches.length && sketches.map( (item) => (
                <SketchTile img={item.pictures[0]} dir={item.dir} key={item.title} updateSelect={setCurr} slct={curr} alt='sketch tile' />
            ))}
        </div>

        {  (Object.keys(curr).length !== 0) && <div onClick={ () => setCurr({}) } className='sketchfeature'><img src = {curr} className='sketchfeatureimg' alt='featured sketch tile' /></div>  }

        </div>
    )

}

export default Sketches;